import { MayNull, noForwardProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import * as R from 'ramda'
import { FC, ReactNode, useEffect, useRef, useState } from 'react'

const Container = styled(Box, noForwardProps)<StickyProps>`
  position: sticky;
  top: ${props => {
    if (props.__topOverflowed > 0) {
      return (props.__topOverflowed - props.__top) * -1 - props.__bottom
    } else {
      return props.__top
    }
  }}px;
`

const ApeironSticky: FC<Props> = props => {
  const { bottom = 0, children, className, top } = props

  const [overflowHeight, setOverflowHeight] = useState<number>(0)

  const ref = useRef(null)

  useEffect(() => {
    const element = ref.current as MayNull<HTMLElement>

    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        const top = element.getBoundingClientRect().y + window.scrollY

        const overflow = R.max(
          top + element.offsetHeight - window.innerHeight,
          0
        )

        setOverflowHeight(overflow)
      })

      resizeObserver.observe(element)

      return () => {
        resizeObserver.unobserve(element)
      }
    }
  }, [ref.current])

  useEffect(() => {
    const onResize = () => {
      const element = ref.current as MayNull<HTMLElement>

      if (element) {
        const top = element.getBoundingClientRect().y + window.scrollY

        const overflow = R.max(
          top + element.offsetHeight - window.innerHeight,
          0
        )

        setOverflowHeight(overflow)
      }
    }

    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return (
    <Container
      __bottom={bottom}
      __top={top}
      __topOverflowed={overflowHeight}
      className={className}
      ref={ref}
    >
      {children}
    </Container>
  )
}

type StickyProps = {
  __bottom: number
  __top: number
  __topOverflowed: number
}

type Props = {
  bottom?: number
  children: ReactNode
  className?: string
  top: number
}

export default ApeironSticky
